/** @hidden */
export function isBoolean(val: any): val is boolean { return typeof val === 'boolean'; }
/** @hidden */
export function isString(val: any): val is string { return typeof val === 'string'; }
/** @hidden */
export function isNumber(val: any): val is number { return typeof val === 'number'; }
/** @hidden */
export function isFunction(val: any): val is Function { return typeof val === 'function'; }
/** @hidden */
export function isDefined(val: any): boolean { return typeof val !== 'undefined'; }
/** @hidden */
export function isUndefined(val: any): val is undefined { return typeof val === 'undefined'; }
/** @hidden */
export function isPresent(val: any): val is any { return val !== undefined && val !== null; }
/** @hidden */
export function isBlank(val: any): val is null { return val === undefined || val === null; }
/** @hidden */
export function isObject(val: any): val is Object { return typeof val === 'object'; }
/** @hidden */
export function isArray(val: any): val is any[] { return Array.isArray(val); }

export class Custom_RequestMethod {
    post: any = "post";
    get: string = "get";
    delete: any = "Delete";
    put: any = "Put";
}

export function removeEmptyKeys(obj: any) {
    return Object.fromEntries(
        Object.entries(obj).filter((entry: any) => (entry[1] != '' && entry[1] != null && entry[1] != undefined))
    )
}
export function ensureHttpPrefix(url: string, notSecure: boolean = false): string {
    // Check if the URL starts with http:// or https://
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      // If not, prepend http:// to the URL
      if(notSecure)
        return 'http://' + url;
        else return 'https://' + url;
    }
    // If the URL already has http:// or https://, return it as is
    return url;
  }

export function encodeSpaces(url: string): string {
    return url.replace(/ /g, '%20');
  }


export function getRange(n: number, start?: number): number[] {
  return Array(n).fill(0).map((_, index) => index + start);
  // return Array(n).fill(0).map((_, index) => index);
}
//https://github.com/ionic-team/ionic-v3/blob/master/src/util/util.ts#L98
